import { SignUpRegisterType } from '../type/signUpRegister.type';

export const signUpRegisterInitial: SignUpRegisterType = {
    success: false,
};
